import * as React from 'react';
import { ReactNode } from 'react';
import { cn, useModal } from '@restworld/utils-common';

import { Button, BaseModal } from '../../../';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IListModalProps {
  children: ReactNode;
  isShowMoreButtonVisible?: boolean;
  modalEl: ReactNode;
}
export const ListModal: React.FunctionComponent<IListModalProps> = ({ children, isShowMoreButtonVisible, modalEl }) => {
  const { show, close, open } = useModal();
  return modalEl ? (
    <>
      {children}
      {isShowMoreButtonVisible && (
        <BaseModal open={show} onClose={close} showMobileGestures={true}>
          <Wrapper>{modalEl}</Wrapper>
        </BaseModal>
      )}
      {isShowMoreButtonVisible && (
        <Button
          onClick={open}
          title="Mostra di più"
          variant="ghost"
          icon="PlusSmallIcon"
          isUnderLined
          fontColor="black"
        />
      )}
    </>
  ) : null;
};

export default ListModal;
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('pb-3', className)} {...props} />
);
